import React from 'react';
import classNames from 'classnames';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import { useTranslation } from 'react-i18next';
import WaitingImage from 'assets/images/members.webp';

import './ShareableLinkWaitingRoom.styles.scss';

type ShareableLinkWaitingRoomProps = {
  className?: string;
};

const ShareableLinkWaitingRoom: React.FC<ShareableLinkWaitingRoomProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('shareable-link-waiting-room', className);

  const { t } = useTranslation();

  return (
    <ShareableLinkLockScreen
      className={classes}
      image={WaitingImage}
      title={t('youAreInWaitingRoom')}
      description={t('requestSubmittedYoullBeNotified')}
    />
  );
};

export default ShareableLinkWaitingRoom;
